import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { ImageDoors } from '../jobs/image-doors.tsx';
import { SampleShelf } from '../jobs/samples.tsx';
import { authClient } from '../lib/auth.ts';

/**
 * «Реклама картинками» — the two doors into the image composer.
 *
 * Both lead to the same screen; the second opens it with a reference already
 * required and the brief re-labelled, because that is what the original does
 * (`prd/domains.md` §7.1). A second composer would be the same screen twice,
 * and the pair of them would drift within a month.
 */
function ImageAds() {
  const { layout } = Route.useSearch();

  return (
    <div className="flex flex-col gap-8">
      <header className="flex flex-wrap items-start gap-4 py-2">
        <h1
          className="min-w-0 flex-1 font-display text-[28px] leading-[34px] font-bold tracking-[-0.7px] text-ink"
          data-testid="image-ads-title"
        >
          Image ads
        </h1>
      </header>

      <section className="flex flex-col gap-4">
        <h2 className="text-[20px] leading-6 font-bold text-ink">Start a still advert</h2>
        <ImageDoors testIdPrefix="door-" />
      </section>

      <SampleShelf layout={layout} />
    </div>
  );
}

export const Route = createFileRoute('/image-ads')({
  beforeLoad: async ({ location }) => {
    const { data } = await authClient.getSession();
    if (!data) throw redirect({ to: '/login', search: { redirectTo: location.href } });
  },
  component: ImageAds,
  /**
   * `?layout=` — which archetype the samples below should already be narrowed
   * to.
   *
   * In the address rather than in a click handler, because that is what makes
   * the shelf on the home page a **link**: it can be middle-clicked, opened in
   * a tab and shared, which is what a tile that looks like a link owes anyone
   * who treats it as one. Not validated against the catalog here — an unknown
   * key narrows to nothing, which is a visibly empty shelf rather than an
   * error page, and the facet above it still works.
   */
  validateSearch: z.object({ layout: z.string().optional() }),
});
